import React, { CSSProperties, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Image, Spin, theme } from "antd";
import img from "../../assets/images/user.png";
import { wrap } from "module";
import {
  CameraOutlined,
  CameraTwoTone,
  CloudUploadOutlined,
} from "@ant-design/icons";
import { useTheme } from "antd-style";
import WithAuth from "../../hoc/WithAuth";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";

const wrapper: CSSProperties = {
  display: "flex",
  width: "100%",
  gap: 10,
  fontSize: 16,
  marginBottom: 20,
  flexDirection: "column",
};
const label: CSSProperties = {
  color: "#128807",
  fontWeight: 500,
  fontSize: 20,
};
const value: CSSProperties = {
  color: "#8590A3",
  fontWeight: 500,
  fontSize: 16,
};

const ProfilePage = () => {
  const { user } = useAuth() as AuthContextValue;
  const { token } = theme.useToken();
  const [file, setFile] = useState<File | null | undefined>(undefined);
  const [upload, setUpload] = useState(false);
  const [tempImage, setTempImage] = useState<any>();

  // const { mutateAsync: uploadProfilePicture, isPending } = useUploadProfilePicture();

  // const { data: user, refetch } = useUserDetail(session?.user.id || '');
  const inputFile = useRef<HTMLInputElement>(null);

  // const uploadAvatar = async () => {
  //     if (file && session) {
  //         const result = await uploadProfilePicture({ id: session?.user.id, file });
  //         refetch();
  //     }
  //     setUpload(false);
  //     setTempImage(undefined);
  // }

  return (
    <div>
      {user && (
        <div
          style={{
            fontFamily: "Poppins",
            padding: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            borderRadius: 8.5,
            marginTop: 25,
            paddingTop: 22,
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "200px",
            }}
          >
            <Image
              preview={false}
              src={img}
              style={{ width: 200, height: 200, borderRadius: 100 }}
            />
            {!upload && (
              <CameraTwoTone
                twoToneColor={token.colorPrimary}
                onClick={() => {
                  if (inputFile && inputFile.current) {
                    inputFile.current.click();
                  }
                }}
                style={{
                  fontSize: 40,
                  position: "absolute",
                  bottom: 10,
                  right: 10,
                }}
              />
            )}
            {/* {upload && <CloudUploadOutlined onClick={uploadAvatar} style={{ color: token.colorPrimary, fontSize: 40, position: 'absolute', bottom: 10, right: 10, }} />}
                    {isPending && <div style={{ position: 'absolute', width: 200, height: 200, backgroundColor: '#33333387', borderRadius: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <Spin style={{ color: token.colorPrimary, fontSize: 40 }} />
                        <div style={{ color: token.colorPrimary, fontFamily: 'Poppins', fontWeight: 600, fontSize: 16 }}>Uploading...</div>
                    </div>} */}
            <input
              type="file"
              id="file"
              onChange={async (e) => {
                if (e && e.target && e.target.files) {
                  setFile(e.target.files[0]);
                  setTempImage(URL.createObjectURL(e.target.files[0]));
                  setUpload(true);
                }
              }}
              ref={inputFile}
              style={{ display: "none" }}
            />
          </div>
          <div style={{ display: "flex", width: "50%", marginBottom: 25 }}>
            <div style={{ width: "100%" }}>
              <div
                style={{
                  fontFamily: "Poppins",
                  fontWeight: 700,
                  borderRadius: "8.5px",
                  backgroundColor: "white",
                  paddingTop: "33px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#E9EDF4",
                    padding: "15px",
                    borderRadius: "8.5px",
                    fontWeight: 500,
                    fontSize: "24px",
                    marginBottom: "30px",
                  }}
                >
                  Personal info
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 20,
                  }}
                >
                  <div style={wrapper}>
                    <div style={label}>Full name</div>
                    <div style={value}>{user.fullName}</div>
                  </div>

                  <div style={wrapper}>
                    <div style={label}>Phone</div>
                    <div style={value}>{user.phoneNo}</div>
                  </div>

                  <div style={wrapper}>
                    <div style={label}>Email</div>
                    <div style={value}>{"user.email"}</div>
                  </div>
                </div>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div className="wrapper">
                    <div className="label">Role</div>
                    <div className="value">{user.roleName}</div>
                  </div>

                  <div className="wrapper">
                    <div className="label">User name</div>
                    <div className="value">{user.userName}</div>
                  </div>

                  <div className="wrapper">
                    <div className="label">Status</div>
                    <div
                      className="value"
                      style={{
                        borderRadius: 5,
                        display: "flex",
                        justifyContent: "center",
                        width: 120,
                        paddingTop: 6,
                        paddingBottom: 6,
                        color: user.status === 1 ? "#4CAF50" : "#F44336",
                        backgroundColor: `${user.status === 1 ? "#4CAF50" : "#F44336"}44`,
                      }}
                    >
                      {user.status === 1 ? "ACTIVE" : "INACTIVE"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WithAuth(ProfilePage);
